import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../store/actions'
import DefaultLayout from '../../layouts/default'
import ArtistHotspot from '../../components/artist-hotspot'
import Loading from '../../components/loading'

function mapStateToProps(state) {
  return { pages: state.pagesData };
}

const mapDispatchToProps = (dispatch) => {
  const { fetchPages } = actions;

  return {
    fetchPages: bindActionCreators(fetchPages, dispatch)
  }
}

class Team extends React.Component {
  render() {
    if (!this.props.pages.length) { return <Loading /> }

    return (
      <DefaultLayout>
        <div className="container container--grid">
          <div className="row">
            <ArtistHotspot pages={ this.props.pages } />
          </div>
        </div>
      </DefaultLayout>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(Team);



// WEBPACK FOOTER //
// ./src/routes/team/index.js